import dayjs from 'dayjs'

export default {
    data() {
      return {
      };
    },
  
    methods: {

        normalizzaTS(aDate, raceDate) {
            //2021-09-15-13:48:18.399
            if (aDate !== undefined) {
                if (raceDate == null) raceDate = "1970-01-01";
                const dataSplit = aDate.split("-");
                if (dataSplit.length == 1) {
                    return raceDate + " " + aDate;
                } else {
                    return dataSplit[0] + "-" + dataSplit[1] + "-" + dataSplit[2] + " " + dataSplit[3];
                }
            }
            return aDate;
        },

        isValidDate(dateToValidate){
            const tt0 = this.normalizzaTS(dateToValidate);
            const t0 = dayjs(this.getIsoDate(tt0))
            return t0.isValid();
        },

        calcolaOrario(guntime, time, timeFormat = 'HH:mm:ss.SSS'){
            var utc = require('dayjs/plugin/utc')
            dayjs.extend(utc);
            
            const tt0 = this.normalizzaTS(guntime);
            const tt1 = this.normalizzaTS(time);
            
            console.log("Calcolo orario:" + tt0 + " + " + tt1 )

            const t0 = dayjs(this.getIsoDate(tt0))+ 3600000;
            const t1 = dayjs(this.getIsoDate(tt1))+ 3600000;

            let result = dayjs(t0.valueOf()+t1.valueOf()).utc().format(timeFormat);

            return result

        },


        diffTime(tempo1, tempo0, gapFormat = 'HH:mm:ss') {
            var utc = require('dayjs/plugin/utc')
            dayjs.extend(utc);

            const tt0 = this.normalizzaTS(tempo0);
            const tt1 = this.normalizzaTS(tempo1);

            const t0 = dayjs(this.getIsoDate(tt0)).utc();
            const t1 = dayjs(this.getIsoDate(tt1)).utc();

            var duration = (t1.diff(t0));
            if (gapFormat == undefined) {
                gapFormat = 'HH:mm:ss'
            }
            let result = dayjs(duration).utc().format('HH:mm:ss.SSS');

            result = this.formatTimestamp(result , gapFormat)
            //if (result.startsWith("+00:"))
            //    result = "+" + result.substring(4, result.length);
            return result;
        },


        diffTimeNew(tempo1, tempo0, gapFormat = 'HH:mm:ss.SSS') {
            // Parsing formato personalizzato
            const parseCustom = (str) => {
                // Divido la parte di data da quella di ora
                const [date, time] = str.split(/-(\d{2}:\d{2}:\d{2}\.\d{3})$/).filter(Boolean);
                return time; // restituisce HH:mm:ss.SSS
            };

            const parseTime = (str) => {
                const [h, m, sMs] = str.split(':');
                const [s, ms = '0'] = sMs.split('.');
                return (parseInt(h) * 3600000) +
                    (parseInt(m) * 60000) +
                    (parseInt(s) * 1000) +
                    parseInt(ms.padEnd(3, '0'));
            };

            const t0 = parseTime(parseCustom(tempo0));
            const t1 = parseTime(parseCustom(tempo1));

            let diff = t1 - t0;
            // Se vuoi il wrap 24h:
            if (diff < 0) diff += 24 * 3600000;

            const hours   = String(Math.floor(diff / 3600000)).padStart(2, '0');
            diff %= 3600000;
            const minutes = String(Math.floor(diff / 60000)).padStart(2, '0');
            diff %= 60000;
            const seconds = String(Math.floor(diff / 1000)).padStart(2, '0');
                const millis  = String(diff % 1000).padStart(3, '0');

                if (gapFormat === 'HH:mm:ss') {
                    return `${hours}:${minutes}:${seconds}`;
                }
                return `${hours}:${minutes}:${seconds}.${millis}`;
        },         

        diffSeconds(tempo1, tempo0) {
            
            var utc = require('dayjs/plugin/utc')
            dayjs.extend(utc);

            const tt0 = this.normalizzaTS(tempo0);
            const tt1 = this.normalizzaTS(tempo1);

            

            const t0 = dayjs(this.getIsoDate(tt0)).utc();
            const t1 = dayjs(this.getIsoDate(tt1)).utc();

            return (t1.diff(t0)) / 1000;
           
        },

        riduci(aTime) {
            if (aTime !== undefined && isNaN(aTime)) {
               // console.log(aTime)
               if (aTime.startsWith("00:0") || aTime.startsWith("00.0")) {
                    return aTime.substring(4, aTime.length);
               } else if (aTime.startsWith("00:") || aTime.startsWith("00.")) {
                    return aTime.substring(3, aTime.length);
                } else if (aTime.startsWith("00:0") || aTime.startsWith("00.0")) {
                    return aTime.substring(5, aTime.length);
                } else if (aTime.startsWith("+00:")) {
                    return aTime.substring(4, aTime.length);
                } else if (aTime.startsWith("+0:")) {
                    return aTime.substring(3, aTime.length);
                } else if (aTime.startsWith("+")) {
                    return aTime.substring(1, aTime.length);
                } else if (aTime.startsWith("0")) {
                    return aTime.substring(1, aTime.length);
                }
            }
            return aTime;
        },

        getTime(tempo) {
            let t = tempo.split(".");
            return t[0];
        },

        getIsoDate(aDate) {
            const res = aDate.replace(/-/g, '/').replace('T', ' ');
            //console.log("getIso:" + aDate + " >> " + res);
            return res;
        },

        calcolaMedia(tempo0, meters, unit) {
            let res = "-";
            //console.log("Media>" + tempo0 + " - " + meters)
            if (tempo0 !== undefined && isNaN(tempo0) && meters > 0 ) {
                var utc = require('dayjs/plugin/utc')
                 dayjs.extend(utc);

            const tt0 = this.normalizzaTS(tempo0);
            const t0 = dayjs(this.getIsoDate(tt0));

            const hh = t0.get('hours') * 3600;
            const mm = t0.get('minutes') * 60;
            const ss = t0.get('seconds');

            let seconds = hh + mm + ss;

            if (unit == undefined || unit == 'Min/Km') {
                let velocita = meters / seconds;
                velocita = 1000 / velocita;
                let resto = (velocita % 60) / 100;
                if (resto > 0.590)
                    resto = 0.59;
                velocita = Math.floor(velocita / 60) + resto;
                velocita = (Math.round((velocita + Number.EPSILON) * 100) / 100).toFixed(2);
    
                res = (velocita)
            } else if ( unit == 'Km/h'){
                const min = (( seconds ) / 60);
				const metriAlMin = (meters / min);
				const velocita = ( (metriAlMin * 60) / 1000 ).toFixed(2);;
				res = (velocita) ;
            } else if (unit == 'Min/100mt' ) {
                let velocita = meters / seconds;
				velocita = 100 / velocita;
				let resto = (velocita % 60) / 100;
                if (resto > 0.590)
                    resto = 0.59;
                velocita = Math.floor(velocita / 60) + resto;
                velocita = (Math.round((velocita + Number.EPSILON) * 100) / 100).toFixed(2);
    
                res = (velocita)
            }
            
            return res;
            }
            return "-";
        },

        formatTimestamp(time, timeFormat = 'HH:mm:ss.SSS'){
            const tt1 = this.normalizzaTS(time);
            let result = dayjs(tt1).format('HH:mm:ss.SSS');

            if (timeFormat.endsWith(".SS") ) {
                result = result.substring(0, result.length-1 );
            } else if (timeFormat.endsWith(".S")){
                result = result.substring(0, result.length-2 );
            } else {
                result = dayjs(tt1).format(timeFormat);
            }
            return result
        },

        subtractMsHHMMSSsss(timeStr, msToSubtract) {
            const m = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)\.(\d{1,3})$/.exec(timeStr);
            if (!m) throw new Error('Formato orario non valido. Atteso HH:mm:ss.SSS');

            let [, HH, MM, SS, SSS] = m;
            let total =
                (+HH) * 3600000 +
                (+MM) * 60000 +
                (+SS) * 1000 +
                (+SSS.padEnd(3, '0'));

            // sottrai e fai wrap nell'intervallo [0, 86400000)
            total = ((total - msToSubtract) % 86400000 + 86400000) % 86400000;

            const h = String(Math.floor(total / 3600000)).padStart(2, '0');
            total %= 3600000;
            const mi = String(Math.floor(total / 60000)).padStart(2, '0');
            total %= 60000;
            const s = String(Math.floor(total / 1000)).padStart(2, '0');
            const ms = String(total % 1000).padStart(3, '0');

            return `${h}:${mi}:${s}.${ms}`;
            }



    }
}